
<template>
  <div id="knowledge-base-page">
    <div class="knowledge-base-jumbotron">
      <div
        class="
          knowledge-base-jumbotron-content
          lg:p-16
          md:p-16
          sm:p-16
          p-8
          rounded-lg
          mb-base
        "
      >
        <h1 class="mb-1 text-white">Welcome to Training Management System</h1>
      </div>
    </div>
    <vs-card>
      <h4>Mail box</h4>
      <div style="float: right">
        <vx-tooltip text="set All as read ">
          <vs-button
            type="icon"
            color="danger"
            @click="SubmitAllAdvertisementNotifyAsRead"
            style="color: red; padding: 0px"
            ><feather-icon
              icon="EyeIcon"
              svgClasses="w-5 h-5 hover:text-primary stroke-current"
          /></vs-button>
        </vx-tooltip>
      </div>

      <div class="vx-row">
        <div
          class="vx-col lg:w-1/3 w-full p-5 mb-5"
          v-for="item in mails"
          :key="item.ID"
        >
          <vs-card
            style="height: 300px; overflow-y: scroll; overflow-x: hidden"
          >
            <vx-tooltip text="set as read ">
              <vs-button
                class="ml-5"
                type="icon"
                color="danger"
                @click="SubmitAdvertisementNotifyAsRead(item)"
                style="color: red; padding: 0px; float: right"
                ><feather-icon
                  icon="EyeIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
              /></vs-button>
            </vx-tooltip>
            <div class="vx-row mt-5" style="padding-left: 20px">
              <p style="max-height: 270px ;font-size:15px" v-html="item.Body"></p>
            </div>
          </vs-card>
        </div>
        <template>
          <vs-pagination
            class="mr-5"
            :total="totalMailPages"
            v-model="currentMailPage"
          ></vs-pagination>
        </template>
      </div>
    </vs-card>

    <vx-card
      class="mt-5"
      card-background="#ebf7ff"
      content-color="#fff"
      v-for="item in courseRequest"
      :key="item.ID"
    >
      <div class="vx-row">
        <div class="vx-col lg:w-1/5 justify-center">
          <img :src="baseUrl + item.Status.ImagePath" alt="" class="w-full" />
        </div>
        <div class="vx-col lg:w-2/5 margin-auto">
          <img class="ml-10" alt="" src="@/assets/images/education.svg" />
          <div class="lg:w-2/3 mt-2 ml-10">
            <h6 style="color: rgb(0 0 0)" v-if="item.Course">
              {{ item.Course.Name }}
            </h6>
            <h6 style="color: rgb(0 0 0)" v-if="!item.Course">
              {{ item.CourseName }}
            </h6>
            <p
              v-if="item.Course"
              style="color: rgb(0 0 0); font-size: smaller"
              v-html="item.Course.ICAOCategory"
            ></p>

            <p class="mt-5" style="color: #ada8a8; font-size: smaller">
              {{$t('Status')}}
            </p>
            <p style="color: rgb(0 0 0); font-size: smaller">
              {{ item.Status.Name }}
            </p>
          </div>
        </div>
        <div class="vx-col lg:w-1/5 margin-auto">
          <h5 style="color: rgb(0 0 0)">{{ item.Status.Description }}</h5>
        </div>
        <div class="vx-col lg:w-1/5 margin-auto">
          <vs-button
            color="#3D7299"
            type="filled"
            icon-pack="feather"
            icon="icon-arrow-right"
            icon-after
            @click="contineRequest()"
            >Continue</vs-button
          >
        </div>
      </div>
    </vx-card>

    <!--  -->
    <vx-card class="mt-5" card-background="#ebf7ff" content-color="#000">
      <div class="vx-row">
        <div class="vx-col lg:w-1/5 justify-center mt-5">
          <img style="width: 12%" alt="" src="@/assets/images/time.svg" />
          <strong> <h5 class="mt-1">Current Courses</h5></strong>
        </div>

        <div
          v-if="currentCourses.length > 0"
          class="vx-col lg:w-1/4 mx-auto"
          v-for="item in currentCourses"
          :key="item.ID"
        >
          <h6 style="color: #3d7299; font-weight: bold">
            {{ item.Course.Name }}
          </h6>
          <p
            style="color: rgb(0 0 0); font-size: smaller"
            v-html="item.Course.ICAOCategory"
          ></p>

          <div class="vx-row mt-2">
            <p style="font-size: 11px; color: #646464">
              {{ item.StartDate.split("T")[0] }} --
              {{ item.EndDate.split("T")[0] }}
            </p>
          </div>
        </div>

        <div
          class="vx-col lg:w-1/5 margin-auto"
          v-if="currentCourses.length > 0"
        >
          <vs-button
            class="items-center mt-6"
            color="#3D7299"
            type="filled"
            icon-pack="feather"
            @click="viewCourseList(1)"
            icon="icon-arrow-right"
            icon-after
            >see more</vs-button
          >
        </div>
        <div
          v-if="currentCourses.length == 0"
          class="vx-row lg:w-3/5 justify-center"
        >
          <img class="w-3/4 mr-auto" alt="" src="@/assets/images/nocors.svg" />
        </div>
      </div>
    </vx-card>

    <!--  -->

    <vx-card card-background="#ebf7ff" class="mt-5" content-color="#000">
      <div class="vx-row">
        <div class="vx-col lg:w-1/5 justify-center mt-8">
          <img style="width: 12%" alt="" src="@/assets/images/history.svg" />
          <strong> <h5 class="mt-1">Obtained Courses</h5></strong>
        </div>

        <div
          v-if="obtainCourses.length > 0"
          class="vx-col lg:w-1/4 mx-auto"
          v-for="item in obtainCourses"
          :key="item.ID"
        >
          <h6 style="color: #3d7299; font-weight: bold">
            {{ item.Course.Name }}
          </h6>
          <p
            style="color: rgb(0 0 0); font-size: smaller"
            v-html="item.Course.ICAOCategory"
          ></p>
          <p style="font-size: 11px; color: #646464">
            {{ item.StartDate.split("T")[0] }}--
            {{ item.EndDate.split("T")[0] }}
          </p>
        </div>
        <div
          class="vx-col lg:w-1/5 margin-auto"
          v-if="obtainCourses.length > 0"
        >
          <vs-button
            class="items-center mt-6"
            color="#3D7299"
            type="filled"
            icon-pack="feather"
            @click="viewCourseList(2)"
            icon="icon-arrow-right"
            icon-after
            >see more</vs-button
          >
        </div>
        <div
          v-if="obtainCourses.length == 0"
          class="vx-row lg:w-3/5 justify-center"
        >
          <img class="w-3/4 mr-auto" alt="" src="@/assets/images/nocors.svg" />
        </div>
      </div>
    </vx-card>

    <vx-card card-background="#ebf7ff" class="mt-5" content-color="#000">
      <div class="vx-row">
        <div class="vx-col lg:w-1/5 justify-center mt-5">
          <img
            style="width: 12%"
            alt=""
            src="@/assets/images/compensation-marker.svg"
          />
          <strong><h5 class="mt-1">Upcoming Courses</h5></strong>
        </div>

        <div
          class="vx-col lg:w-1/4 mx-auto"
          v-if="upcomingCourses.length > 0"
          v-for="item in upcomingCourses"
          :key="item.ID"
        >
          <h6 style="color: #3d7299; font-weight: bold">
            {{ item.Course.Name }}
          </h6>
          <p
            class="mt-3"
            style="color: rgb(0 0 0); font-size: smaller"
            v-html="item.Course.ICAOCategory"
          ></p>
          <p style="font-size: 11px; color: #646464">
            {{ item.StartDate.split("T")[0] }} --
            {{ item.EndDate.split("T")[0] }}
          </p>
        </div>

        <div
          class="vx-col lg:w-1/5 margin-auto"
          v-if="upcomingCourses.length > 0"
        >
          <vs-button
            class="items-center mt-6"
            color="#3D7299"
            type="filled"
            icon-pack="feather"
            icon="icon-arrow-right"
            @click="openUpcomingCourses()"
            icon-after
            >see more</vs-button
          >
        </div>
        <div
          v-if="upcomingCourses.length == 0"
          class="vx-row lg:w-3/5 justify-center"
        >
          <img class="w-3/4 mr-auto" alt="" src="@/assets/images/nocors.svg" />
        </div>
      </div>
    </vx-card>

    <vx-card :style="catelogBG" class="mt-5">
      <div class="vx-row">
        <div class="vx-row mx-auto justify-center">
          <img class="w-1/2" alt="" src="@/assets/images/booook.svg" />
        </div>
        <div class="vx-col mt-12 mr-16">
          <vs-button
            class="items-center"
            color="#3D7299"
            type="filled"
            icon-pack="feather"
            icon="icon-arrow-right"
            @click="downloadCalender()"
            icon-after
            >{{$t('Download')}} {{ annualCalender.Year }} Catalogue</vs-button
          >
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import moduleCustomer from "@/store/user/customer/moduleCustomer.js";
import TraineeAnnualSearch from "../trainee/TraineeAnnualSearch.vue";
import { domain } from "@/gloabelConstant.js";

export default {
  data() {
    return {
      baseUrl: domain,
      knowledgeBaseSearchQuery: "",
      AdvertisementNotify: [],
      currentMailPage: 1,
      mailsPerPage: 3,
    };
  },

  computed: {
    courseRequest() {
      return this.$store.state.customerList.homeData.CourseRequest;
    },
    currentCourses() {
      return this.$store.state.customerList.homeData.CurrentCourses.slice(0, 2);
    },
    obtainCourses() {
      return this.$store.state.customerList.homeData.ObtainCourses.slice(0, 2);
    },
    upcomingCourses() {
      return this.$store.state.customerList.homeData.UpcomingCourses;
    },
    annualCalender() {
      return this.$store.state.customerList.homeData.AnnualCalender;
    },
    allMails() {
      return this.$store.state.customerList.mails;
    },
    mails() {
      var index = (this.currentMailPage - 1) * this.mailsPerPage;
      return this.$store.state.customerList.mails.slice(
        index,
        index + this.mailsPerPage
      );
    },
    totalMailPages() {
      return Math.ceil(
        this.$store.state.customerList.mails.length / this.mailsPerPage
      );
    },
    filteredKB() {
      return this.kb.filter(
        (item) =>
          item.title
            .toLowerCase()
            .includes(this.knowledgeBaseSearchQuery.toLowerCase()) ||
          item.description
            .toLowerCase()
            .includes(this.knowledgeBaseSearchQuery.toLowerCase())
      );
    },
  },
  created() {
    if (!moduleCustomer.isRegistered) {
      this.$store.registerModule("customerList", moduleCustomer);
      moduleCustomer.isRegistered = true;
    }
    this.$store
      .dispatch("customerList/getCustomerAdvertisementNotify")
      .then((res) => {
        this.AdvertisementNotify = res.data;
        debugger;
      });
    this.$store.commit("auth/SET_BEARER", localStorage.getItem("accessToken"));

     this.$store.dispatch("customerList/CustomerHomeData");
  },

  methods: {
    downloadCalender() {
      window.open(this.baseUrl + this.annualCalender.Attachment, "_blank");
    },
    viewCourseList(id) {
      this.$router.push({ name: "CourseList", params: { ID: id } });
    },
    openUpcomingCourses() {
      this.$router.push({ name: "UpcomingCourse" });
    },
    contineRequest() {
      this.$router.push({ name: "FollowCourseRequest" });
    },

    notifyAlert(color, title, text) {
      this.$vs.notify({
        color: color,
        title: title,
        text: text,
      });
    },
    SubmitAllAdvertisementNotifyAsRead() {
      debugger;
      this.$store
        .dispatch(
          "customerList/SubmitAllAdvertisementNotifyAsRead",
          this.AdvertisementNotify
        )
        .then((res) => {
          if (res.data == true) {
            this.notifyAlert(
              "success",
              this.$t("Done"),
              this.$t("MarkAllAsReadisDoneSuccessfully")

            );
          } else {
            this.notifyAlert("denger",this.$t("Failed"), this.$t("thereareaproblem"));
          }
        });
    },
    SubmitAdvertisementNotifyAsRead(AdvertisementNotify) {
      debugger;
      this.$store
        .dispatch(
          "customerList/SubmitAdvertisementNotifyAsRead",
          AdvertisementNotify
        )
        .then((res) => {
          if (res.data == true) {
            this.notifyAlert(
              "success",
              "Done",
              this.$t("MarkAsReadisDoneSuccessfully")
            );
          } else {
            this.notifyAlert("denger", this.$t("Failed"), this.$t("thereareaproblem"));
          }
        });
    },
  },
  components: {
    TraineeAnnualSearch,
  },
};
</script>
<style >
iframe {
  max-width: 90%;
}
img {
  max-width: 60%;
  max-height: 50%;
}
</style>
<style lang="scss">
.knowledge-base-jumbotron-content {
  background-image: url("../../assets/images/pages/knowledge-base-cover.jpg");
  background-size: cover;
}
</style>
